import React, { useMemo } from 'react';
import { classNames } from '@src/utils';
import './item-block.scss';
import { useCallback } from 'react';
var prefixCls = 'item-block';
var ItemBlock = function (props) {
    var data = props.data, onClickItemBlock = props.onClickItemBlock;
    var appid = data.appid;
    var className = useMemo(function () { return classNames(prefixCls, props.data.sysID); }, [props.data.sysID]);
    var handleOnClick = useCallback(function () {
        onClickItemBlock(appid);
    }, [onClickItemBlock, appid]);
    return data.enable === 1 ? (React.createElement("div", { className: className, style: props.style, onClick: handleOnClick },
        React.createElement("div", { className: prefixCls + "_icon" },
            React.createElement("img", { src: data.logoUrl
                    ? data.logoUrl
                    : 'http://xuexin-web.oss-cn-shanghai.aliyuncs.com/images/auth/sys-default-image.png' })),
        React.createElement("div", { className: prefixCls + "_detail" },
            React.createElement("div", { className: prefixCls + "_detail_title" }, data.sysName),
            React.createElement("p", { className: prefixCls + "_detail_description" }, data.introduction)))) : (React.createElement("div", { className: className, style: props.style },
        React.createElement("span", { className: "tip" }, "\u7CFB\u7EDF\u5347\u7EA7\u4E2D"),
        React.createElement("div", { className: prefixCls + "_icon" },
            React.createElement("img", { src: data.logoUrl
                    ? data.logoUrl
                    : 'http://xuexin-web.oss-cn-shanghai.aliyuncs.com/images/auth/sys-default-image.png', alt: "", className: "img" })),
        React.createElement("div", { className: prefixCls + "_detail" },
            React.createElement("div", { className: prefixCls + "_detail_title" }, data.sysName),
            React.createElement("p", { className: prefixCls + "_detail_description" }, data.introduction))));
};
export default React.memo(ItemBlock);
